<div *ngIf="state.step < 5" class="wrapper-sign-up">
  <!-- Ambient background glow elements -->
  <div class="ambient-glow glow-1"></div>
  <div class="ambient-glow glow-2"></div>
  <div class="ambient-glow glow-3"></div>

  <!-- Header Navigation -->
  <nav class="navbar navbar-expand-lg signup-navbar">
    <div class="container-xl d-flex justify-content-between align-items-center">
      <div class="section-logo">
        <a class="navbar-brand brand-link" [routerLink]="'/homepage'">
          <img
            class="logo"
            src="https://cdn.estore5s.com/asset/estore-logo-transparent.png"
            alt="estore-logo"
          />
        </a>
      </div>
      <div class="header-badges d-none d-md-flex align-items-center">
        <div class="secure-badge">
          <i class="fas fa-shield-alt text-emerald-400 mr-2"></i>
          <span>{{ 'Fast & Secure Setup' | translate }}</span>
        </div>
      </div>
    </div>
  </nav>

  <div
    class="section-sign-up-step container-xl"
    [class.step4-container]="state.step == 4"
    [formGroup]="storeForm"
  >
    <!-- Stepper Navigation -->
    <div
      class="section-stepper"
      *ngIf="state.step > 0"
    >
      <div class="stepper-track">
        <!-- Step 1 Node -->
        <div
          class="stepper-node"
          [class.active]="state.step === 1"
          [class.completed]="state.step > 1"
          (click)="gotoStep(1)"
        >
          <div class="node-circle">
            <i *ngIf="state.step > 1" class="fas fa-check"></i>
            <span *ngIf="state.step <= 1">01</span>
          </div>
          <div class="node-label">
            <span class="step-num">Step 1</span>
            <span class="step-title">{{ 'Store Identity' | translate }}</span>
          </div>
        </div>

        <!-- Connector 1 -->
        <div
          class="stepper-connector"
          [class.active]="state.step > 1"
          [class.in-progress]="state.step === 1"
        ></div>

        <!-- Step 2 Node (Subdomain) -->
        <div
          class="stepper-node"
          [class.active]="state.step === 3"
          [class.completed]="state.step > 3"
          (click)="gotoStep(3)"
        >
          <div class="node-circle">
            <i *ngIf="state.step > 3" class="fas fa-check"></i>
            <span *ngIf="state.step <= 3">02</span>
          </div>
          <div class="node-label">
            <span class="step-num">Step 2</span>
            <span class="step-title">{{ 'Domain & URL' | translate }}</span>
          </div>
        </div>

        <!-- Connector 2 -->
        <div
          class="stepper-connector"
          [class.active]="state.step === 5"
          [class.in-progress]="state.step === 3"
        ></div>

        <!-- Step 3 Node (Summary & Ready) -->
        <div
          class="stepper-node"
          [class.active]="state.step === 5"
          [class.completed]="state.step === 5"
        >
          <div class="node-circle">
            <span>03</span>
          </div>
          <div class="node-label">
            <span class="step-num">Step 3</span>
            <span class="step-title">{{ 'Launch' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Card Container -->
    <div class="signup-card-container">
      <div class="card card-form glass-card">
        <!-- STEP 0: Email Confirmation -->
        <div *ngIf="state.step == 0" class="step-pane step-email">
          <div class="step-header text-center">
            <span class="step-badge">
              <i class="fas fa-envelope mr-1"></i> {{ 'GET STARTED' | translate }}
            </span>
            <h1 class="card-title">{{ 'Store Email Address' | translate }}</h1>
            <p class="card-subtitle">
              {{ 'Enter your email address to link and manage your new eStore' | translate }}
            </p>
          </div>

          <div class="form mt-4">
            <div class="form-group custom-input-group">
              <label class="form-label"
                >{{ 'Email Address' | translate }} <span class="required-star">*</span></label
              >
              <div class="input-with-icon">
                <i class="fas fa-envelope input-icon"></i>
                <input
                  type="email"
                  class="form-control main-input-0"
                  placeholder="e.g. storeowner@gmail.com"
                  (keyup.enter)="nextStepOnEnter($event)"
                  [class.is-invalid]="email.touched && email.invalid"
                  formControlName="email"
                />
              </div>
              <span
                *ngIf="!email.touched || email.valid; else invalidEmail"
                class="form-help-text"
              >
                <i class="fas fa-info-circle mr-1"></i>
                {{ 'Your eStore ownership and notifications will be linked to this email.' | translate }}
              </span>
              <ng-template #invalidEmail>
                <div class="invalid-feedback d-block">
                  <ng-container
                    *ngIf="email.errors?.required || email.errors?.pattern"
                  >
                    {{ 'Please provide a valid email address.' | translate }}
                  </ng-container>
                  <ng-container *ngIf="email.errors?.taken">
                    {{ email.errors.taken }}
                  </ng-container>
                </div>
              </ng-template>
            </div>

            <div class="form-actions mt-5 d-flex justify-content-end">
              <button
                [disabled]="email.invalid"
                (click)="submitEmail()"
                class="btn btn-primary-gradient btn-lg"
              >
                <span>{{ 'Confirm Email & Continue' | translate }}</span>
                <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- STEP 1: Store Identity (Name, Country, Language) -->
        <div *ngIf="state.step == 1" class="step-pane step-identity">
          <div class="step-header text-center">
            <span class="step-badge">
              <i class="fas fa-store mr-1"></i> {{ 'STEP 01 • STORE SETUP' | translate }}
            </span>
            <h1 class="card-title">{{ 'Create an Identity for Your eStore' | translate }}</h1>
            <p class="card-subtitle">
              {{ 'Fill in your store details and choose your target market region.' | translate }}
            </p>
          </div>

          <div class="form mt-4">
            <!-- Store Name -->
            <div class="form-group custom-input-group">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label mb-0">
                  {{ 'Store Name' | translate }} <span class="required-star">*</span>
                </label>
                <span class="char-count" [class.text-amber-500]="name.value?.length > 50">
                  {{ name.value?.length || 0 }}/64
                </span>
              </div>
              <div class="input-with-icon">
                <i class="fas fa-store-alt input-icon"></i>
                <input
                  type="text"
                  class="form-control main-input-1"
                  placeholder="{{ 'e.g. 5S Wellness Global' | translate }}"
                  maxlength="64"
                  (keyup.enter)="validateStoreInfo()"
                  [class.is-invalid]="name.touched && name.invalid"
                  formControlName="name"
                />
              </div>
              <div class="invalid-feedback d-block" *ngIf="name.touched && name.invalid">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ 'Please provide a valid store name (minimum 5 characters).' | translate }}
              </div>
              <span class="form-help-text" *ngIf="!name.invalid">
                <i class="fas fa-magic mr-1 text-blue-400"></i>
                {{ 'We will automatically suggest a matching web address based on this name.' | translate }}
              </span>
            </div>

            <!-- Two Column: Country & Language -->
            <div class="row">
              <!-- Default Country -->
              <div class="col-12 col-md-6">
                <div class="form-group custom-input-group">
                  <label class="form-label">
                    {{ 'Default Country' | translate }} <span class="required-star">*</span>
                  </label>
                  <div ngbDropdown class="w-100 dropdown-custom-container">
                    <button
                      class="btn btn-dropdown-trigger form-control d-flex align-items-center justify-content-between"
                      [class.is-invalid]="country.touched && country.invalid"
                      id="dropdownCountry"
                      ngbDropdownToggle
                    >
                      <div class="selected-content d-flex align-items-center">
                        <ng-container
                          *ngIf="country.value !== ''; else placeholderCountryContent"
                        >
                          <img class="flag-icon mr-2" [src]="country.value.country_flag" alt="flag" />
                          <span class="selected-text">{{ country.value.country_name }}</span>
                        </ng-container>
                        <ng-template #placeholderCountryContent>
                          <i class="fas fa-globe-asia mr-2 text-muted"></i>
                          <span class="placeholder-text">{{ 'Choose a country' | translate }}</span>
                        </ng-template>
                      </div>
                      <i class="fas fa-chevron-down chevron-icon"></i>
                    </button>
                    <div class="invalid-feedback d-block" *ngIf="country.touched && country.invalid">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      {{ 'Please choose a default country.' | translate }}
                    </div>
                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownCountry"
                      class="custom-dropdown-menu"
                    >
                      <div class="dropdown-menu-inner">
                        <ng-container *ngFor="let ctry of countries$ | async">
                          <button
                            ngbDropdownItem
                            class="dropdown-item-option d-flex align-items-center"
                            [class.selected]="country.value?.country_code === ctry.country_code"
                            (click)="country.patchValue(ctry)"
                            *ngIf="!['MYZZ', 'MYXX'].includes(ctry.country_code)"
                          >
                            <img class="flag-icon mr-2" [src]="ctry.country_flag" alt="flag" />
                            <span class="flex-grow-1">{{ ctry.country_name }}</span>
                            <i class="fas fa-check check-selected" *ngIf="country.value?.country_code === ctry.country_code"></i>
                          </button>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Default Language -->
              <div class="col-12 col-md-6">
                <div class="form-group custom-input-group">
                  <label class="form-label">
                    {{ 'Default Language' | translate }} <span class="required-star">*</span>
                  </label>
                  <div ngbDropdown class="w-100 dropdown-custom-container">
                    <button
                      class="btn btn-dropdown-trigger form-control d-flex align-items-center justify-content-between"
                      [class.is-invalid]="language.touched && language.invalid"
                      id="dropdownLanguage"
                      ngbDropdownToggle
                    >
                      <div class="selected-content d-flex align-items-center">
                        <ng-container
                          *ngIf="language.value !== ''; else placeholderLanguageContent"
                        >
                          <i class="fas fa-language mr-2 text-blue-500"></i>
                          <span class="selected-text">{{ language.value.language_name }}</span>
                        </ng-container>
                        <ng-template #placeholderLanguageContent>
                          <i class="fas fa-language mr-2 text-muted"></i>
                          <span class="placeholder-text">{{ 'Choose a language' | translate }}</span>
                        </ng-template>
                      </div>
                      <i class="fas fa-chevron-down chevron-icon"></i>
                    </button>
                    <div class="invalid-feedback d-block" *ngIf="language.touched && language.invalid">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      {{ 'Please choose a default language.' | translate }}
                    </div>
                    <div
                      ngbDropdownMenu
                      aria-labelledby="dropdownLanguage"
                      class="custom-dropdown-menu"
                    >
                      <div class="dropdown-menu-inner">
                        <button
                          ngbDropdownItem
                          class="dropdown-item-option d-flex align-items-center"
                          [class.selected]="language.value?.language_code === lang.language_code"
                          *ngFor="let lang of languages$ | async"
                          (click)="language.patchValue(lang)"
                        >
                          <i class="fas fa-language mr-2 text-blue-500"></i>
                          <span class="flex-grow-1">{{ lang.language_name }}</span>
                          <i class="fas fa-check check-selected" *ngIf="language.value?.language_code === lang.language_code"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="form-actions mt-5 d-flex justify-content-between align-items-center">
              <div>
                <button
                  *ngIf="state.emailRequired"
                  (click)="prevStep()"
                  class="btn btn-outline-secondary btn-lg"
                >
                  <i class="fas fa-arrow-left mr-2"></i>
                  <span>{{ 'Back' | translate }}</span>
                </button>
              </div>
              <button
                [disabled]="name.invalid"
                (click)="validateStoreInfo()"
                class="btn btn-primary-gradient btn-lg ml-auto"
              >
                <span>{{ 'Continue to Subdomain' | translate }}</span>
                <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- STEP 2: Plan Selection (If enabled) -->
        <div *ngIf="state.step == 2" class="step-pane step-plan">
          <div class="step-header text-center">
            <span class="step-badge">
              <i class="fas fa-tags mr-1"></i> {{ 'STEP 02 • SELECT PLAN' | translate }}
            </span>
            <h1 class="card-title">{{ 'Choose the Best Plan for Your Store' | translate }}</h1>
            <p class="card-subtitle">
              {{ 'Pick the plan that fits your business goals right now. You can upgrade anytime.' | translate }}
            </p>
          </div>

          <div class="form mt-4">
            <div class="plan-selection-container row">
              <ng-container *ngFor="let plan of plans$ | async; let i = index">
                <div class="col-12 col-md-4 mb-3">
                  <div
                    class="card-plan modern-plan-card"
                    [class.active]="plan.id == storePlan.value.id"
                    [class.disabled]="!state.allowFreeStore && plan.plan_code === freePlanCode"
                    (click)="updatePlan(plan)"
                  >
                    <div class="plan-selected-badge" *ngIf="plan.id == storePlan.value.id">
                      <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="plan-icon-wrapper">
                      <img
                        [src]="'assets/' + plan.plan_name.toLowerCase() + '.png'"
                        alt="plan"
                        (error)="$event.target.style.display='none'"
                      />
                    </div>
                    <h3 class="plan-title">{{ plan.plan_name }}</h3>
                    <div class="plan-price-tag">
                      <span class="price-val">
                        {{ plan.plan_price == 0 ? ('Free' | translate) : ((plan.plan_price | currency:'MYR':'RM ') + '/mo') }}
                      </span>
                    </div>
                    <ul class="plan-features-list">
                      <li *ngFor="let desc of getList(plan.plan_desc)">
                        <i class="fas fa-check text-emerald-500 mr-2"></i>
                        <span>{{ desc }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="form-actions mt-5 d-flex justify-content-between align-items-center">
              <button (click)="prevStep()" class="btn btn-outline-secondary btn-lg">
                <i class="fas fa-arrow-left mr-2"></i>
                <span>{{ 'Back' | translate }}</span>
              </button>
              <button (click)="nextStep()" class="btn btn-primary-gradient btn-lg">
                <span>{{ 'Next Step' | translate }}</span>
                <i class="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- STEP 3: Subdomain & Web Address -->
        <div *ngIf="state.step == 3" class="step-pane step-domain">
          <div class="step-header text-center">
            <span class="step-badge">
              <i class="fas fa-globe mr-1"></i> {{ 'STEP 02 • STORE WEB ADDRESS' | translate }}
            </span>
            <h1 class="card-title">{{ 'Choose Your Store Subdomain' | translate }}</h1>
            <p class="card-subtitle">
              {{ 'Give your customers a clean, memorable URL to visit your online eStore.' | translate }}
            </p>
          </div>

          <div class="form mt-4">
            <!-- Subdomain Input Group -->
            <div class="form-group custom-input-group">
              <label class="form-label">
                {{ 'Store Subdomain URL' | translate }} <span class="required-star">*</span>
              </label>

              <div class="domain-input-wrapper" [class.is-invalid]="subdomainName.touched && subdomainName.invalid">
                <div class="domain-prefix">https://</div>
                <input
                  type="text"
                  class="form-control domain-input main-input-3"
                  placeholder="e.g. 5s-wellness"
                  maxlength="24"
                  (keyup.enter)="validateDomain()"
                  [class.is-invalid]="subdomainName.touched && subdomainName.invalid"
                  oninput="this.value = this.value.toLowerCase()"
                  formControlName="subdomainName"
                />
                <div class="domain-suffix">.{{ storeSubdomain }}</div>
              </div>

              <!-- Live URL Preview Pill -->
              <div class="live-url-preview mt-2" *ngIf="subdomainName.value">
                <i class="fas fa-link mr-1 text-blue-400"></i>
                <span class="preview-label">{{ 'Live Store Address:' | translate }}</span>
                <strong class="preview-url">https://{{ subdomainName.value }}.{{ storeSubdomain }}</strong>
              </div>

              <!-- Error feedback -->
              <div class="invalid-feedback d-block mt-2" *ngIf="subdomainName.invalid">
                <ng-container
                  *ngIf="subdomainName.errors?.required || subdomainName.errors?.pattern || subdomainName.errors?.minlength"
                >
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  {{ 'Please provide a valid subdomain (5-24 lowercase characters, numbers or hyphens).' | translate }}
                </ng-container>
                <ng-container *ngIf="subdomainName.errors?.taken">
                  <i class="fas fa-times-circle mr-1 text-danger"></i>
                  {{ 'Subdomain is already taken. Please try another one.' | translate }}
                </ng-container>
                <ng-container *ngIf="subdomainName.errors?.error_msg">
                  <i class="fas fa-exclamation-triangle mr-1 text-warning"></i>
                  {{ subdomainName.errors.error_msg }}
                </ng-container>

                <div class="mt-2" *ngIf="subdomainName.errors?.error_msg">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-info rounded-pill"
                    (click)="showRestrictedWordModal()"
                  >
                    <i class="fas fa-info-circle mr-1"></i>
                    {{ 'View restricted domain names' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Custom Domain (Optional toggle if needed) -->
            <div class="form-group mt-3" *ngIf="useCustomDomain.value">
              <label class="form-label">
                {{ 'Custom Domain' | translate }}
              </label>
              <div class="domain-input-wrapper">
                <div class="domain-prefix">https://www.</div>
                <input
                  type="text"
                  class="form-control domain-input"
                  [class.is-invalid]="customDomain.touched && customDomain.invalid"
                  formControlName="customDomain"
                  (keyup.enter)="nextStepOnEnter($event)"
                  oninput="this.value = this.value.toLowerCase()"
                  placeholder="yourbrand.com"
                />
              </div>
              <div class="invalid-feedback d-block" *ngIf="customDomain.invalid">
                <ng-container *ngIf="customDomain.errors?.required || customDomain.errors?.pattern">
                  {{ 'Please provide a valid custom domain name.' | translate }}
                </ng-container>
                <ng-container *ngIf="customDomain.errors?.taken">
                  {{ 'Custom domain is not available.' | translate }}
                </ng-container>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="form-actions mt-5 d-flex justify-content-between align-items-center">
              <button (click)="prevStep()" class="btn btn-outline-secondary btn-lg">
                <i class="fas fa-arrow-left mr-2"></i>
                <span>{{ 'Back' | translate }}</span>
              </button>
              <button
                (click)="validateDomain()"
                class="btn btn-primary-gradient btn-lg"
                [disabled]="!canValidateDomain"
              >
                <span>{{ 'Finish & Proceed to Summary' | translate }}</span>
                <i class="fas fa-sparkles ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer for step < 5 -->
<div *ngIf="state.step < 5" class="footer container-fluid py-3" #footerContent>
  <p class="text-center text-slate-400 mb-0 font-sm">
    {{ 'eStore ' | translate }}&copy; {{ ' Copyright ' | translate }}
    {{ currentYear }}. {{ 'All Rights Reserved.' | translate }}
  </p>
</div>

<!-- STEP 5: Summary & Launch Screen ("Get ready to roll!") -->
<div *ngIf="state.step == 5" class="wrapper-ready">
  <!-- Ambient background glow elements -->
  <div class="ambient-glow glow-1"></div>
  <div class="ambient-glow glow-2"></div>

  <!-- Header Navigation -->
  <nav class="navbar navbar-expand-lg ready-navbar">
    <div class="container-xl d-flex justify-content-between align-items-center">
      <div class="section-logo">
        <a class="navbar-brand brand-link" [routerLink]="'/homepage'">
          <img
            class="logo"
            src="https://cdn.estore5s.com/asset/estore-logo-transparent.png"
            alt="estore-logo"
          />
        </a>
      </div>
      <div class="ready-badge">
        <i class="fas fa-rocket text-amber-400 mr-2"></i>
        <span>{{ 'Ready to Launch' | translate }}</span>
      </div>
    </div>
  </nav>

  <div class="section-ready container-xl">
    <!-- Header Hero -->
    <div class="ready-hero text-center">
      <span class="hero-chip">
        <i class="fas fa-check-circle mr-1 text-emerald-400"></i>
        {{ 'CONFIGURATION COMPLETE' | translate }}
      </span>
      <h1 class="ready-title">
        <span>{{ 'Get Ready to' | translate }}</span>
        <span class="gradient-text"> {{ 'Roll & Launch!' | translate }}</span>
      </h1>
      <p class="ready-subtitle">
        {{ 'Welcome aboard! Review your store configurations below and launch your brand new eStore in one click.' | translate }}
      </p>
    </div>

    <!-- Main Content Split -->
    <div class="row section-content mt-4 align-items-start">
      <!-- Left Visual Card -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0">
        <div class="ready-visual-card glass-card">
          <div class="store-preview-header">
            <div class="window-dots">
              <span class="dot red"></span>
              <span class="dot yellow"></span>
              <span class="dot green"></span>
            </div>
            <div class="window-url-bar">
              <i class="fas fa-lock text-emerald-400 mr-2"></i>
              <span class="url-text">https://{{ subdomainName.value }}.{{ storeSubdomain }}</span>
            </div>
          </div>
          <div class="store-preview-body text-center">
            <div class="store-avatar-circle">
              <i class="fas fa-store-alt"></i>
            </div>
            <h3 class="preview-store-name">{{ form.value.name }}</h3>
            <p class="preview-store-tag">
              <img class="flag-mini mr-1" [src]="country?.value?.country_flag" alt="flag" *ngIf="country?.value?.country_flag" />
              <span>{{ country?.value?.country_name }}</span>
              <span class="mx-2">•</span>
              <span>{{ language?.value?.language_name }}</span>
            </p>
            <div class="launch-ready-pill">
              <i class="fas fa-bolt text-amber-400 mr-1"></i>
              <span>{{ 'Ready for deployment' | translate }}</span>
            </div>
          </div>
          <div class="store-preview-footer">
            <div class="stat-item">
              <span class="stat-label">{{ 'Plan' | translate }}</span>
              <span class="stat-val font-weight-bold text-blue-400">Standard</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-label">{{ 'SSL Security' | translate }}</span>
              <span class="stat-val font-weight-bold text-emerald-400">Active</span>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <span class="stat-label">{{ 'Status' | translate }}</span>
              <span class="stat-val font-weight-bold text-indigo-400">Pending Launch</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Summary & Actions -->
      <div class="col-12 col-lg-7">
        <div class="summary-wrapper glass-card">
          <h2 class="summary-section-title">
            <i class="fas fa-clipboard-list text-blue-400 mr-2"></i>
            {{ 'Store Setup Summary' | translate }}
          </h2>

          <div class="summary-items-list">
            <!-- Store Name Item -->
            <div class="summary-item-row">
              <div class="item-icon-box">
                <i class="fas fa-store"></i>
              </div>
              <div class="item-details">
                <span class="item-label">{{ 'Store Name' | translate }}</span>
                <span class="item-value">{{ form.value.name }}</span>
              </div>
              <div class="item-status">
                <i class="fas fa-check-circle text-emerald-400"></i>
              </div>
            </div>

            <!-- Country Item -->
            <div class="summary-item-row">
              <div class="item-icon-box">
                <i class="fas fa-globe-americas"></i>
              </div>
              <div class="item-details">
                <span class="item-label">{{ 'Target Country' | translate }}</span>
                <span class="item-value d-flex align-items-center">
                  <img class="flag-icon-sm mr-2" [src]="country?.value?.country_flag" alt="flag" *ngIf="country?.value?.country_flag" />
                  {{ country?.value?.country_name }}
                </span>
              </div>
              <div class="item-status">
                <i class="fas fa-check-circle text-emerald-400"></i>
              </div>
            </div>

            <!-- Language Item -->
            <div class="summary-item-row">
              <div class="item-icon-box">
                <i class="fas fa-language"></i>
              </div>
              <div class="item-details">
                <span class="item-label">{{ 'Default Language' | translate }}</span>
                <span class="item-value">{{ language?.value?.language_name }}</span>
              </div>
              <div class="item-status">
                <i class="fas fa-check-circle text-emerald-400"></i>
              </div>
            </div>

            <!-- Subdomain URL Item -->
            <div class="summary-item-row">
              <div class="item-icon-box">
                <i class="fas fa-link"></i>
              </div>
              <div class="item-details">
                <span class="item-label">{{ 'Store URL' | translate }}</span>
                <span class="item-value text-blue-400 font-mono">
                  https://{{ subdomainName.value }}.{{ storeSubdomain }}
                </span>
              </div>
              <div class="item-status">
                <i class="fas fa-check-circle text-emerald-400"></i>
              </div>
            </div>
          </div>

          <!-- AI Content Generation Box -->
          <div
            class="ai-generation-card modern-ai-box mt-4"
            [class.disabled]="!aiGenerateStoreContentFeatureEnabled || !dealerCreditsLoaded || dealerCreditsLoading || dealerCredits < dealerMinimumCredit || !dealerCreditsValid"
            [class.active]="aiGenerateContentEnabled"
            [class.loading]="dealerCreditsLoading"
            (click)="aiGenerateStoreContentFeatureEnabled && onAiGenerateCardClick($event)"
            [ngbPopover]="aiGeneratePopover"
            popoverTitle="What AI will generate"
            triggers="mouseenter:mouseleave"
            placement="top"
            container="body"
          >
            <ng-template #aiGeneratePopover>
              <div style="max-width: 340px">
                <div class="mb-2 font-weight-bold">
                  {{ 'AI can help generate content for your product pages and store SEO, including:' | translate }}
                </div>
                <ul class="mb-0 pl-3">
                  <li>{{ 'Product overview & descriptions' | translate }}</li>
                  <li>{{ 'Directions for use & ingredients' | translate }}</li>
                  <li>{{ 'Product FAQs & specifications' | translate }}</li>
                  <li>{{ 'Product & Store Global SEO' | translate }}</li>
                  <li><em>{{ 'and more...' | translate }}</em></li>
                </ul>
              </div>
            </ng-template>

            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="ai-sparkle-icon mr-3">
                  <i class="fas fa-magic"></i>
                </div>
                <div>
                  <div class="d-flex align-items-center">
                    <h4 class="ai-box-title mb-0">
                      {{ 'Auto-generate store content with AI' | translate }}
                    </h4>
                    <span class="badge badge-warning ml-2" *ngIf="!aiGenerateStoreContentFeatureEnabled">
                      {{ 'Coming soon!' | translate }}
                    </span>
                    <span class="ai-pill-tag ml-2" *ngIf="aiGenerateStoreContentFeatureEnabled">
                      {{ '⚡ Smart' | translate }}
                    </span>
                  </div>
                  <p class="ai-box-desc mb-0 mt-1">
                    {{ 'Instantly generate rich product descriptions, localized SEO metadata, and FAQs.' | translate }}
                  </p>
                </div>
              </div>

              <div class="ai-toggle-wrapper">
                <div
                  class="ai-loading-spinner"
                  *ngIf="dealerCreditsLoading"
                  aria-label="Loading credits"
                >
                  <span class="spinner-border spinner-border-sm text-blue-400" role="status"></span>
                </div>

                <div class="custom-control custom-switch modern-switch" *ngIf="!dealerCreditsLoading">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="aiGenerateStoreContent"
                    [checked]="aiGenerateContentEnabled"
                    [disabled]="!aiGenerateStoreContentFeatureEnabled || !dealerCreditsLoaded || dealerCreditsLoading || dealerCredits < dealerMinimumCredit || !dealerCreditsValid"
                    (change)="onAiGenerateStoreContentChange($event.target.checked)"
                    (click)="$event.stopPropagation()"
                  />
                  <label
                    class="custom-control-label"
                    for="aiGenerateStoreContent"
                    (click)="$event.stopPropagation()"
                  ></label>
                </div>
              </div>
            </div>

            <!-- Credit Warning -->
            <div
              class="credit-warning-pill mt-3"
              *ngIf="dealerCreditsLoaded && (dealerCredits < dealerMinimumCredit || !dealerCreditsValid)"
            >
              <i class="fas fa-exclamation-triangle mr-2"></i>
              <span>
                {{ 'You need at least' | translate }}
                <strong>{{ dealerMinimumCredit }} {{ 'credits' | translate }}</strong>
                {{ 'to enable AI generation.' | translate }}
              </span>
            </div>

            <!-- Time Notice -->
            <div
              class="ai-time-pill mt-3"
              *ngIf="aiGenerateContentEnabled"
              (click)="$event.stopPropagation()"
            >
              <i class="far fa-clock mr-2 text-blue-400"></i>
              <span>
                {{ 'Estimated generation time:' | translate }}
                <strong>{{ aiGenerationEstimatedTime.min }} - {{ aiGenerationEstimatedTime.max }} {{ 'minutes' | translate }}</strong>.
                <small class="d-block text-slate-400 mt-1">
                  {{ 'Each additional language adds approx. 3 minutes.' | translate }}
                </small>
              </span>
            </div>

            <!-- AI Multi-language Selection -->
            <div
              class="ai-language-box mt-3"
              *ngIf="aiGenerateContentEnabled && languageList?.length"
              (click)="$event.stopPropagation()"
            >
              <div class="ai-lang-label mb-2">
                {{ 'Select languages to generate content in:' | translate }}
              </div>
              <div class="ai-lang-chips">
                <div
                  class="lang-chip-item"
                  *ngFor="let lang of languageList"
                  [class.selected]="isAiLanguageSelected(lang.language_code)"
                  [class.disabled]="isDefaultAiLanguage(lang.language_code)"
                  (click)="toggleAiLanguage(lang.language_code)"
                >
                  <i class="fas fa-check-circle mr-1 check-icon" *ngIf="isAiLanguageSelected(lang.language_code)"></i>
                  <span>{{ lang.language_name }}</span>
                  <span class="default-badge" *ngIf="isDefaultAiLanguage(lang.language_code)">
                    ({{ 'Default' | translate }})
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Proceed Button Actions -->
          <div class="summary-actions mt-5 d-flex justify-content-between align-items-center">
            <button (click)="prevStep()" class="btn btn-outline-secondary btn-lg">
              <i class="fas fa-arrow-left mr-2"></i>
              <span>{{ 'Return' | translate }}</span>
            </button>
            <button
              class="btn btn-primary-gradient btn-lg btn-launch-store"
              (click)="createNewStore()"
              [disabled]="state.submitting || dealerCreditsLoading"
            >
              <span
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                *ngIf="dealerCreditsLoading || state.submitting"
              ></span>
              <i class="fas fa-rocket mr-2" *ngIf="!dealerCreditsLoading && !state.submitting"></i>
              <span>{{ dealerCreditsLoading ? ('Loading...' | translate) : ('Create & Launch eStore' | translate) }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-white container-fluid py-3 mt-5">
    <p class="text-center text-slate-400 mb-0 font-sm">
      {{ 'eStore ' | translate }}&copy; {{ ' Copyright ' | translate }}
      {{ currentYear }}. {{ 'All Rights Reserved.' | translate }}
    </p>
  </div>
</div>

<!-- Restricted Words Modal -->
<ng-template #restrictedWordsModalContent let-modal>
  <div class="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <div class="modal-icon-badge mr-2">
        <i class="fas fa-shield-alt text-amber-500"></i>
      </div>
      <h5 class="modal-title font-weight-bold">{{ 'Restricted Domain Names' | translate }}</h5>
    </div>
    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="modal.close()"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center my-2 restricted-name-modal">
    <p class="text-muted font-sm mb-3">
      {{ 'The following subdomain names are reserved by the system and cannot be registered:' | translate }}
    </p>
    <div class="restricted-list-chips">
      <span class="restricted-chip" *ngFor="let item of restrictedWords">
        {{ item }}
      </span>
    </div>
  </div>
  <div class="modal-footer border-0 pt-0">
    <button class="btn btn-primary-gradient btn-sm w-100" (click)="modal.close()">
      {{ 'Understood' | translate }}
    </button>
  </div>
</ng-template>

<!-- Custom Domain / Step Loading Modal -->
<ng-template #customDomainContent let-modal>
  <div class="modal-body text-center py-5 loading-dialog-modal">
    <div class="loading-spinner-wrapper mb-4">
      <div class="spinner-ring"></div>
      <i class="fas fa-store spinner-center-icon"></i>
    </div>
    <h4 class="loading-title mb-2">
      <ng-container *ngIf="state.step == 0">{{ 'Validating Email Address' | translate }}</ng-container>
      <ng-container *ngIf="state.step == 3">{{ 'Validating Subdomain Availability' | translate }}</ng-container>
      <ng-container *ngIf="state.step == 5">{{ 'Building & Launching Your eStore' | translate }}</ng-container>
    </h4>
    <p class="loading-subtitle text-muted mb-0">
      {{ 'Please wait a moment while we configure your store...' | translate }}
    </p>
  </div>
</ng-template>
